import _ from 'lodash'
import Papa from 'papaparse'
import {listToMap} from './media'
import FileDownload from 'file-saver'
import {IDataSourceItem, IDataSourceItemMap} from '@/features/data-sources'

// export const eachStreamLine = bluebird.promisify<IMediaItem[], NodeJS.ReadableStream, (val:string) => void>(lineReader.eachLine);

export function exportAsFile(items: Partial<IDataSourceItem>[], name?: string) {
  const res = _.chain(items)
    .compact()
    .map((item) => JSON.stringify(item) + '\n')
    .value()
  if (res.length > 0) res[res.length - 1] = _.trimEnd(res[res.length - 1]) // no trailing newline
  if (!name) name = `vionlabs-${new Date().toISOString()}.jsonl`
  FileDownload(new Blob(res, {type: 'text/plain;charset=utf-8'}), name)
}

export async function readAnyLines(file: File): Promise<IDataSourceItemMap | undefined> {
  let res: IDataSourceItemMap | undefined = undefined
  if (_.endsWith(file.name, '.jsonl') || _.endsWith(file.name, '.ndjson')) {
    res = await readJSONLines(file)
  } else if (file.type === 'text/csv') {
    res = await readCSVLines(file)
  } else if (_.endsWith(file.name, '.json')) {
    res = await readJSONBlob(file)
  }
  if (!res) console.error('Failed to read file', file)
  return res
}

function appendFileMeta(item: any, file: File, line: number) {
  return {
    ...item,
    _file: {
      name: file.name,
      line,
    },
  }
}

export async function readJSONBlob(file: File): Promise<IDataSourceItemMap> {
  const fileData = _.chain([await file.text()])
    .compact()
    .map((line, i) => {
      const item = JSON.parse(line)
      if (!item) return
      return appendFileMeta(item, file, i)
    })
    .compact()
    .value()
  return listToMap(fileData, `file_${file.name}`)
}

export async function readJSONLines(file: File): Promise<IDataSourceItemMap> {
  const fileData = _.chain(await file.text())
    .split('\n')
    .compact()
    .map((line, i) => {
      let item: any = undefined
      try {
        item = JSON.parse(line)
      } catch (error) {
        console.error('Failed at deserializing JSON', error, line)
      }
      if (!item) return
      return appendFileMeta(item, file, i)
    })
    .compact()
    .value()
  return listToMap(fileData, `file_${file.name}`)
}

export async function readCSVLines(file: File): Promise<IDataSourceItemMap> {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      transform: (value) => {
        return value.trim()
      },
      complete: (results) => {
        return resolve(
          listToMap(
            _.map(results.data, (v, i) => appendFileMeta(v, file, i)),
            `file_${file.name}`
          )
        )
      },
      error: (error) => {
        return reject(error)
      },
    })
  })
}
